import { Color, shadowConst } from '@klarna/designtokens';
var shadowValues = {
  s: {
    offsetX: 0,
    offsetY: 2,
    blurRadius: 4,
    spreadRadius: 0,
    color: new Color('rgba(0, 0, 0, 0.1)'),
    elevation: 3
  },
  m: {
    offsetX: 0,
    offsetY: 6,
    blurRadius: 12,
    spreadRadius: 0,
    color: new Color('rgba(0, 0, 0, 0.1)'),
    elevation: 11
  },
  l: {
    offsetX: 0,
    offsetY: 12,
    blurRadius: 24,
    spreadRadius: 0,
    color: new Color('rgba(0, 0, 0, 0.1)'),
    elevation: 17
  },
  none: undefined
};
export var defaultShadows = {
  'shadow/s': shadowConst(shadowValues.s),
  'shadow/m': shadowConst(shadowValues.m),
  'shadow/l': shadowConst(shadowValues.l),
  'shadow/none': shadowConst(shadowValues.none)
};
//# sourceMappingURL=index.js.map